import React from "react";
import { Separator } from "../components/ui/separator";
import Footer from "./components/Footer";

export default function AboutPage() {
  return (
    <>
    <div className="min-h-screen pt-24 sm:pt-32 pb-32 px-4 sm:px-6 md:px-12 lg:px-24" data-testid="about-page">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-16 items-start">
          <div className="relative animate-fade-in">
            <img src="./assets/images/mainPicture.png" alt="Tajti Zoltán" className="w-full rounded-xl sm:rounded-2xl shadow-2xl" />
            <img src="./assets/images/albumart.jpg" alt="Tajti Zoltán" className="w-full rounded-xl sm:rounded-2xl shadow-2xl mt-3" />
            <img src="./assets/images/main2.png" alt="Tajti Zoltán" className="w-full rounded-xl sm:rounded-2xl shadow-2xl mt-3" />
          </div>
          <div className="animate-fade-in stagger-1">
            <p className="text-[10px] sm:text-xs uppercase tracking-[0.2em] text-primary mb-2 sm:mb-4">Bemutatkozás</p>
            <h1 className="text-3xl sm:text-5xl font-bold font-['Syne'] tracking-tighter mb-6">
              Tajti Zoltán: A színek és árnyékok útján
            </h1>
            <div className="space-y-4 text-sm sm:text-lg text-muted-foreground leading-relaxed">
              <p style={{ textAlign: 'justify' }}>
                <span className="text-white font-semibold">
                  A salgótarjáni némaságtól a dallamokig (1992–1998)
                </span>
                <br/>
                Minden 1992-ben kezdődött Salgótarjánban, az ipari hegyek és a végtelen erdők ölelésében.
                Ez a vidék megtanítja az embert a csendre. De 1998-ban, hatévesen valami megváltozott:
                az ujjaim először érintették meg egy billentyűs hangszer fekete-fehér világát.
              </p>
              <p style={{ textAlign: 'justify' }}>
                <span className="text-white font-semibold">
                  Az első nagy pofon: X-Faktor és a kijózanodás<br/>
                </span>
                2011-ben, tizenkilenc évesen, hittel és naivitással vágtam neki az ország legnagyobb tehetségkutatójának.
                Az X-Faktor színpada hatalmas volt, a fények vakítóak, a csend pedig, ami a kiesésem után fogadott,
                fülsiketítő.<br/>

                Hosszú évek teltek el a „szürke zónában”. Zenéltem, tanultam, éltem a hétköznapi emberek életét.
                De a zene sosem hagyott nyugodni, ott dobolt a fejemben minden átvirrasztott éjszakán.
              </p>
              <p style={{ textAlign: 'justify' }}>
                <span className="text-white font-semibold">
                  2025: Amikor a lélek darabokra hullik<br/>
                </span>
                Vannak pillanatok, amik kettétörik az életet. Számomra ez a válásom volt. Amikor a házam kiürült,
                és csak a hangszereim maradtak velem, rájöttem, hogy nincs hová menekülnöm.<br/>
                <span className="text-white font-semibold">A katarzis:</span> A fájdalom nem bénított meg, hanem felszabadított.
                Leültem a gép elé, és megszületett a <bold className="text-primary">„Belül könnyezem”</bold><br/>
                <span className="text-white font-semibold">Az alkotói láz:</span> Azóta nem tudom abbahagyni. Ontom magamból a
                zenét. Van, hogy hajnali háromkor ébredek egy dallamra, és addig nem fekszem vissza, amíg a gépbe nem kerül.
                A zeném a terápiám, a vallomásom és a túlélésem.
              </p>
              <p style={{ textAlign: 'justify' }}>
                <span className="text-white font-semibold">
                  2026: A visszatérés és a Színesre festett világ<br/>
                </span>
                Ma már nem a fájdalom határoz meg, hanem az, amit tanultam belőle. A <b className="text-primary">„Színesre festett világ”</b>
                nem csak egy dalcím – ez az új életfilozófiám.<br/>
                <span className="text-white font-semibold">A misszió:</span> Megmutatni, hogy a legmélyebb gyászból is születhet vibráló, színes élet.<br/>
                <span className="text-white font-semibold">A terv:</span> 2026-ban, 15 évvel az első kudarcom után,
                készen állok. Újra megmérettetem magam ott, ahol egyszer elbuktam. Nem ugyanaz az ember vagyok,
                aki 2011-ben volt. Most már van mondanivalóm.
              </p>
              <p style={{ textAlign: 'justify' }}>
                <span className="text-white font-semibold">
                  MIÉRT LÉPJ BE A VILÁGOMBA?
                </span>
                <br/>
                A weboldalam nem egy sima médiafelület. Ez a TZ-Közösség bázisa. Azért hoztam létre a fanclubot,
                mert a zenémnek szüksége van azokra, akik értik a mélységeket.<br/>
                <br/>
                <span className="text-white font-semibold">Mit kapsz, ha csatlakozol?</span>
                <ol style={{ marginTop: '1rem' }}>
                  <li>
                    <span className="text-white font-semibold">A nyers igazság:</span> Olyan stúdió-vlogokat és „így készült” videókat,
                    ahol látod a könnyeimet és az izzadtságomat is, nem csak a végeredményt.
                  </li>
                  <li>
                    <span className="text-white font-semibold">A Close Friends kör:</span> Beengedlek a „Szűk barátok”
                    közé, ahol 24 órás betekintést kapsz az életembe.
                  </li>
                  <li>
                    <span className="text-white font-semibold">Elsőbbség:</span> e hallod a dalokat először,
                    és akár Te dönthetsz el olyan dolgokat, amikről más csak a hírekben olvas.
                  </li>
                </ol>
              </p>
              <p style={{ textAlign: 'justify' }}>
                <span className="text-white font-semibold">
                A zene segített nekem túlélni a legnehezebb évemet. Most szeretném, ha te is részese lennél ennek
                az újjászületésnek.
                </span>
              </p>
            </div>
            <div className="mt-8 flex gap-6">
              <div className="text-center"><p className="text-3xl font-bold font-['Syne'] text-primary">1</p><p className="text-xs text-muted-foreground">Album</p></div>
              <Separator orientation="vertical" className="h-12 bg-white/10" />
              <div className="text-center"><p className="text-3xl font-bold font-['Syne'] text-primary">0+</p><p className="text-xs text-muted-foreground">Koncert</p></div>
              <Separator orientation="vertical" className="h-12 bg-white/10" />
              <div className="text-center"><p className="text-3xl font-bold font-['Syne'] text-primary">200K+</p><p className="text-xs text-muted-foreground">Hallgató</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
}
